<template>
  <div class="upload-button">
    <div class="general-progress">
      <button class="button open" @click="onClick">
        <div class="progress">
          <div
            :class="`progress-bar ${generalStatus}`"
            :style="`width: ${progress || 0}%;`"
          />
          <p class="open__text">
            <slot />
            {{ `${buttonText} (${uploadsCount}) ` }}
            <i v-if="isOpen" class="fa fa-caret-up open__icon ml-20" aria-hidden="true" />
            <i v-else class="fa fa-caret-down open__icon ml-20" aria-hidden="true" />
          </p>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadManagerButton',

  props: {
    progress: {
      type: Number,
      required: true,
    },
    uploadsCount: {
      type: Number,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    generalStatus: {
      type: String,
      required: true,
    },
  },

  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>



// WEBPACK FOOTER //
// UploadManagerButton.vue?2fef5412